import type { Release } from '../releases';

export default {
  id: '2026-11-02-site-reopen',
  at: '2026-11-03T05:58:00Z',
  title: 'Площадка: принятый отчёт смены можно открыть снова',
  modules: ['site'],
  items: [
    'Руководитель проекта может открыть принятый отчёт смены снова — на странице проверки, с обязательной причиной. Факт работ в графике и затраты по этому отчёту снимаются, отчёт возвращается автору.',
    'Автор исправляет отчёт и сдаёт его заново; после повторного принятия объём попадает в график и бюджет один раз — по исправленной версии.',
    'Если по отчёту уже списаны материалы со склада, портал сначала попросит сторнировать списание на складе: иначе материалы списались бы дважды.',
  ],
  why: 'Ошибку в принятом отчёте нельзя было исправить: неверный объём оставался в графике и затратах навсегда.',
  link: '/site/review',
} satisfies Release;
